const faqs = [
  {
    q: '网红黑料的信息来源可靠吗？',
    a: '我们坚持多方交叉验证原则。每一条网红黑料在发布前都经过至少两个独立信息来源的比对核实。对于无法确认的内容，我们会标注"待核实"而非直接发布。我们珍视平台的信誉，绝不传播未经证实的谣言。',
  },
  {
    q: '更新频率是怎样的？每天有多少新内容？',
    a: '我们的编辑团队7×24小时轮值监控全网网红动态。正常情况下每天更新30-50条网红黑料快讯，以及2-3篇深度专题报道。重大事件发生时会在15分钟内发布首条快讯。',
  },
  {
    q: '如何投稿爆料？我的隐私会被保护吗？',
    a: '您可以通过页面底部的联系方式向我们投稿。我们接受文字、截图、视频等多种形式的证据材料。所有爆料人信息均采用端到端加密存储，投稿方身份信息严格保密，不会在任何情况下向第三方透露。',
  },
  {
    q: '被报道的网红可以要求删除内容吗？',
    a: '如果内容存在事实性错误，欢迎通过官方渠道提交更正申请及证明材料，我们会在核实后及时更正或补充。但对于真实、有据可查的内容，我们坚持新闻原则，不接受无理由的删稿要求。',
  },
  {
    q: '除了抖音和快手，还关注其他平台的网红吗？',
    a: '目前我们的核心报道范围覆盖抖音、快手两大平台的头部及腰部网红。同时也在逐步扩展对B站、小红书、视频号等平台的关注。如果您想看到更多平台的网红黑料，欢迎反馈给我们。',
  },
  {
    q: '如何分辨真实爆料和恶意造谣？',
    a: '这是我们最重视的问题之一。每篇报道我们都会尽可能标注信息来源和证据链。读者在阅读时可以参考：一看是否有具体的时间、地点、人物信息；二看是否有可验证的图片/视频证据；三看相关当事人是否有公开回应。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">常见问题</h2>
            <p className="mt-2 text-sm text-foreground-500">关于网红黑料平台，你关心的都在这里</p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="rounded-xl bg-background-200/70 border border-background-300/40 p-5"
              >
                <h3 className="text-sm font-semibold text-foreground-900 flex items-start gap-3">
                  <span className="flex-shrink-0 text-primary-500 mt-0.5">Q</span>
                  <span>{faq.q}</span>
                </h3>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed pl-8">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}